function isNetworkError(error) {
  return error && error.xhr;
}
export function getErrorStatusCode(crmError) {
  if (!crmError || !crmError.networkError || !isNetworkError(crmError.networkError)) {
    return undefined;
  }
  return crmError.networkError.status;
}